// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7e-4";
export var collapsed = "_7e-1";
export var headerBar = "_7e-0";
export var leftHeaderContent = "_7e-3";
export var subjectContainer = "_7e-2";